import { Tag, TypingIndicator } from 'ui/atoms';
import { MarkdownRenderer } from 'ui/molecules/MarkdownRenderer';
import PHIProtection from '../PHIProtection';

import './conversation-response-row.css';
import ConversationResponseSources from '../ConversationResponseSources';
import ConversationResponseImage from '../ConversationResponseImage';

const ConversationResponseRow = ({
  message,
  profileImg,
  isError = false,
  allowRetry = false,
  isGuardRailed = false,
  guardRailType = 'default',
  userConfirmedPHIAllowed = false,
  sources = null,
  imageReferences,
}) => {
  const canDisplayMessage = !isGuardRailed;
  const messageText = message.message;
  const isLoading = message.generationStatus === 'loading';
  const isPendingState = message.generationStatus === 'pending';
  const hasImageReferences =
    imageReferences !== undefined &&
    imageReferences !== null &&
    imageReferences.length > 0;
  const waitingForImages = !isLoading && isPendingState && !hasImageReferences;

  return (
    <div className="message">
      <div className={`response${isError ? ' error' : ''}`}>
        <img src={profileImg} alt="profile-pic" />

        {isGuardRailed && <PHIProtection type={guardRailType} />}

        {canDisplayMessage && (
          <>
            {!isError && (
              <div className="generated-response-row">
                {userConfirmedPHIAllowed && (
                  <Tag>Generated using prompt that may contain PHI</Tag>
                )}
                {isLoading ? (
                  <TypingIndicator />
                ) : (
                  <MarkdownRenderer text={messageText} />
                )}

                {waitingForImages && (
                  <div
                    className="image-loading-placeholder"
                    aria-label="Loading images"
                  >
                    <div className="image-loading-shimmer" />
                  </div>
                )}
                {imageReferences &&
                  imageReferences.length > 0 &&
                  imageReferences.map((img: { imageUri: string }) => (
                    <ConversationResponseImage
                      key={img.imageUri}
                      src={img.imageUri}
                    />
                  ))}
                {sources && (
                  <ConversationResponseSources
                    sources={sources}
                    messageId={message.id}
                  />
                )}
              </div>
            )}
            {isError && (
              <span className="error-message">
                We're having a little trouble generating a response.{' '}
                {allowRetry && (
                  <span>Would you like to try regenerating that response?</span>
                )}
              </span>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ConversationResponseRow;
